"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _image = require("@site/pattern-library-core/image");
var _tag = _interopRequireDefault(require("@site/pattern-library-core/tag"));
var _text = _interopRequireDefault(require("@ux/text"));
var _actions = _interopRequireDefault(require("@site/pattern-library-core/actions"));
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
/* eslint-disable max-len */

const Container = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Container",
  class: "pl-c4yhtz7"
});
const ImageContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ImageContainer",
  class: "pl-iwtbdxz"
});
const ContentContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ContentContainer",
  class: "pl-c1ur30co"
});
const UpperContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "UpperContainer",
  class: "pl-u1o2v2ct"
});
const LowerContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "LowerContainer",
  class: "pl-l1d3p87n"
});
const ButtonContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ButtonContainer",
  class: "pl-blv4ceh"
});

/**
 * ImageTile Component.
 *
 * @param {Object} props React props
 * @returns {React.ReactElement} ImageTile Component
 * @public
 */

function ImageTile({
  image,
  tagLabel,
  title,
  description,
  tutorialLength,
  ctas
}) {
  return /*#__PURE__*/_react.default.createElement(Container, null, /*#__PURE__*/_react.default.createElement(ImageContainer, null, /*#__PURE__*/_react.default.createElement(_image.LazyImage, {
    dataCy: 'attachment-image',
    url: image?.url,
    altText: image?.altText,
    height: image?.height,
    width: image?.width
  })), /*#__PURE__*/_react.default.createElement(ContentContainer, null, /*#__PURE__*/_react.default.createElement(UpperContainer, null, /*#__PURE__*/_react.default.createElement(_tag.default, {
    className: "tag",
    text: tagLabel,
    design: 'warning',
    size: "sm"
  }), /*#__PURE__*/_react.default.createElement(_text.default.p, {
    as: "heading",
    text: title,
    size: 0,
    className: "gdSherpa"
  }), /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_tag.default, {
    className: "tag",
    text: tagLabel,
    design: 'passive',
    size: "sm"
  })), /*#__PURE__*/_react.default.createElement(_text.default.p, {
    as: "paragraph",
    text: description,
    size: -1
  })), /*#__PURE__*/_react.default.createElement(LowerContainer, null, /*#__PURE__*/_react.default.createElement(_text.default.p, {
    as: "paragraph",
    text: tutorialLength,
    size: -1
  }), ctas && /*#__PURE__*/_react.default.createElement(ButtonContainer, null, /*#__PURE__*/_react.default.createElement(_actions.default, {
    actionsLayout: "button-set",
    ctas: ctas
  })))));
}
var _default = exports.default = ImageTile;
ImageTile.propTypes = {
  image: _propTypes.default.shape({
    url: _propTypes.default.string,
    altText: _propTypes.default.string,
    height: _propTypes.default.number,
    width: _propTypes.default.number
  }),
  tagLabel: _propTypes.default.string,
  title: _propTypes.default.string,
  description: _propTypes.default.string,
  tutorialLength: _propTypes.default.string,
  ctas: _propTypes.default.arrayOf(_propTypes.default.shape({
    text: _propTypes.default.string,
    href: _propTypes.default.string,
    design: _propTypes.default.string,
    size: _propTypes.default.string,
    templateName: _propTypes.default.string,
    width: _propTypes.default.string
  }))
};